export const DEFAULT_PRECISION_DECIMALS = 8;

export const roundToFixedPoint = (
  value: number,
  decimals: number = DEFAULT_PRECISION_DECIMALS
): number => {
  return parseFloat(value.toFixed(decimals));
};
